import {List} from 'reactstrap';

const Question = ({question, onChange}) => {
    return (
        <div id="question">
            <h3>{question.id} - {question.text}</h3>
            <List type="unstyled">
                {question.answers.map((answer, idx) => (
                    <li key={idx}>
                        <label><input name="AnswerGroup" type="radio"
                                      value={answer.value}
                                      onChange={() => onChange(question.id, answer.value)}
                                      checked={question.selectedAnswer === answer.value}/> {answer.text}</label>
                    </li>
                ))}
            </List>
        </div>
    );
};

export default Question;
